/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leavetitle1Inputs */

const en_leavetitle1 = /** @type {(inputs: Leavetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave this page?`)
};

const de_leavetitle1 = /** @type {(inputs: Leavetitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seite verlassen?`)
};

/**
* | output |
* | --- |
* | "Leave this page?" |
*
* @param {Leavetitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const leavetitle1 = /** @type {((inputs?: Leavetitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leavetitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leavetitle1(inputs)
	return de_leavetitle1(inputs)
});
export { leavetitle1 as "leaveTitle" }